import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export const ClientAccountDialog = ({ target, onClose }) => {
  const [form, setForm] = useState({ email: "", name: "", password: "" });
  const [busy, setBusy] = useState(false);

  const create = async () => {
    if (!form.email || form.email.includes(" ") || form.email.length < 3) return toast.error("Username must be at least 3 characters with no spaces");
    if ((form.password || "").length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/projects/${target.id}/client-account`, form);
      toast.success(data.existing ? `Linked existing client "${data.username}" to ${data.project}` : `Client account "${data.username}" created for ${data.project}`);
      onClose();
      setForm({ email: "", name: "", password: "" });
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="client-account-dialog">
        <DialogHeader><DialogTitle className="font-display">Client account - {target?.name}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">Creates a <b>Client Viewer</b> login that can only see this project. Share the username &amp; password with your client.</p>
          <div><Label>Username</Label><Input data-testid="ca-username" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" placeholder="e.g. kingo-client" /></div>
          <div><Label>Display name</Label><Input data-testid="ca-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" placeholder="e.g. Kingo Minerals Ltd" /></div>
          <div><Label>Password</Label><Input data-testid="ca-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1" placeholder="At least 8 characters" /></div>
        </div>
        <DialogFooter><Button onClick={create} disabled={busy} className="w-full" data-testid="ca-create">{busy ? "Creating…" : "Create client account"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
